import React, { useState } from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';
import { createRef } from 'react';
import styled from 'styled-components';

import InputStandard from '@components/InputStandard';
import Select from '@components/Select';
import { FILE_STATUS_LIST } from '@config/constants';
import useAPI from '@hooks/useAPI';
import Button from '@shared/Button';
import ErrorMessage from '@src/components/Input/ErrorMessage';
import Spinner from '@src/components/shared/Spinner';
const Container = styled.div`
  width: 70%;
  margin: auto;
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
`;
const SelectContainer = styled.div`
  width: 30%;
  margin: 0 30px;

  svg {
    top: 10px;
  }
`;
const FileUploadContainer = styled.div`
  width: 45%;
  margin-right: 10px;
`;
const CancelContainer = styled.div`
  width: 10%;
`;
const WrapperSubmit = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default function OverrideFiles() {
  const options = [
    [FILE_STATUS_LIST.keep, FILE_STATUS_LIST.keep],
    [FILE_STATUS_LIST.replace, FILE_STATUS_LIST.replace],
    [FILE_STATUS_LIST.discard, FILE_STATUS_LIST.discard],
  ];
  const newFileOptions = [
    [FILE_STATUS_LIST.keep, FILE_STATUS_LIST.keep],
    [FILE_STATUS_LIST.replace, FILE_STATUS_LIST.replace],
  ];

  const [files, setFiles] = useState([]);
  const [newFile, setNewFile] = useState([]);
  const [newConfigParams, setNewConfigParams] = useState([]);
  const [newActiveHolderName, setNewActiveHolderName] = useState('');
  const [countOfUploadedFiles, setCountOfUploadedFiles] = useState(0);
  const [configActiveParams, setConfigActiveParams] = useState([]);
  const [errorMsg, setErrorMsg] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

  const activeFolderData = useAPI(
    'get',
    'ScreenConsoleKeyApi',
    'active_folder'
  );

  const initialFiles = activeFolderData?.response?.folder_files?.map(
    (fileName, index) => {
      return {
        id: index,
        name: fileName,
        status: FILE_STATUS_LIST.keep,
        isOriginFile: true,
        file: null,
      };
    }
  );

  const newConfigResponse = useAPI(...newConfigParams); // set new configuration to upload files
  const fileUploadResponse = useAPI(...newFile); // upload local files
  const configActiveResponse = useAPI(...configActiveParams); // make configuration active

  useEffect(() => {
    if (
      activeFolderData &&
      activeFolderData.response &&
      !activeFolderData.isLoading
    ) {
      setErrorMsg('');
    } else if (activeFolderData?.error) {
      setErrorMsg(activeFolderData.error);
    }
  }, [JSON.stringify(activeFolderData)]);

  useEffect(() => {
    if (initialFiles?.length > 0) {
      setFiles(initialFiles);
    }
  }, [JSON.stringify(initialFiles)]);

  // should disable submit button when same file names exists
  useEffect(() => {
    if (files.length > 0) {
      const fileNames = files.map(file => file.name);
      if (new Set(fileNames).size !== fileNames.length) {
        setIsSubmitDisabled(true);
        setErrorMsg('there should be no repeated file names');
      } else {
        setIsSubmitDisabled(false);
        setErrorMsg('');
      }
    }
  }, [files]);

  useEffect(() => {
    if (
      newConfigResponse &&
      newConfigResponse.response &&
      !newConfigResponse.isLoading
    ) {
      //upload files
      const uploadFiles = files.filter(file => file.file);
      setErrorMsg('');
      if (uploadFiles.length === 0) {
        setConfigActiveParams([
          'post',
          'ScreenConsoleApi',
          `make-active/${process.env.REACT_APP_CUSTOMER_ID}/${newActiveHolderName}`,
          '',
          false,
          '',
          false,
        ]);
      } else {
        for (let i = 0; i < uploadFiles.length; i++) {
          const fd = new FormData();
          fd.append('file', uploadFiles[i].file);
          setTimeout(
            () =>
              setNewFile([
                'post',
                'ScreenConsoleApi',
                `upload/${process.env.REACT_APP_CUSTOMER_ID}/${newActiveHolderName}/${uploadFiles[i].name}`,
                '',
                false,
                '',
                false,
                fd,
              ]),
            0
          );
        }
      }
    } else if (newConfigResponse?.error) {
      setErrorMsg(newConfigResponse.error);
      setIsUploading(false);
    }
  }, [JSON.stringify(newConfigResponse)]);

  useEffect(() => {
    if (
      configActiveResponse &&
      configActiveResponse.response &&
      !configActiveResponse.isLoading
    ) {
      setErrorMsg('');
      setIsUploading(false);
    } else if (configActiveResponse?.error) {
      setErrorMsg(configActiveResponse.error);
      setIsUploading(false);
    }
  }, [JSON.stringify(configActiveResponse)]);

  useEffect(() => {
    if (
      fileUploadResponse &&
      fileUploadResponse.response &&
      !fileUploadResponse.isLoading
    ) {
      setErrorMsg('');
      setCountOfUploadedFiles(countOfUploadedFiles + 1);
      const uploadFiles = files.filter(file => file.file);
      if (countOfUploadedFiles + 1 === uploadFiles.length) {
        setConfigActiveParams([
          'post',
          'ScreenConsoleApi',
          `make-active/${process.env.REACT_APP_CUSTOMER_ID}/${newActiveHolderName}`,
          '',
          false,
          '',
          false,
        ]);
      }
    } else if (fileUploadResponse?.error) {
      setErrorMsg(fileUploadResponse.error);
      setIsUploading(false);
    }
  }, [JSON.stringify(fileUploadResponse)]);

  const hiddenFileInput = useRef([]);
  if (hiddenFileInput.current.length !== files.length) {
    // add or remove refs
    hiddenFileInput.current = Array(files.length)
      .fill()
      .map((_, i) => hiddenFileInput.current[i] || createRef());
  }

  const handleUpload = id => {
    hiddenFileInput.current[id].click();
  };

  const handleChange = (event, id) => {
    const fileUploaded = document.getElementById(`file-${id}`).files[0];

    const newFiles = files.map(item => {
      if (item.id === id) {
        const updatedItem = {
          ...item,
          name: fileUploaded.name,
          file: fileUploaded,
        };
        return updatedItem;
      }
      return item;
    });
    setFiles(newFiles);
  };

  const onChangeStatus = (status, id) => {
    const newFiles = files.map(item => {
      if (item.id === id) {
        const updatedItem = {
          ...item,
          status: status,
        };
        return updatedItem;
      }
      return item;
    });
    setFiles(newFiles);
  };

  const handleAdd = () => {
    const newFiles = [
      ...files,
      {
        id: Date.now(),
        name: '',
        status: FILE_STATUS_LIST.keep,
        isOriginFile: false,
        file: null,
      },
    ];
    setFiles(newFiles);
  };

  const handleSubmit = () => {
    setIsUploading(true);
    const activeFolder = activeFolderData?.response?.active_folder;
    const newFolderName = Date.now();
    setNewActiveHolderName(newFolderName.toString());

    const copyFiles = files.filter(
      file =>
        file.isOriginFile &&
        !file.file &&
        file.status !== FILE_STATUS_LIST.discard
    );

    const uploadFiles = files.filter(file => file.file);

    const body = {
      name: newFolderName.toString(),
      source: activeFolder,
      copy: copyFiles.map(file => file.name),
      upload: uploadFiles.map(file => file.name),
    };
    setNewConfigParams([
      'post',
      'ScreenConsoleApi',
      'create_new_config',
      '',
      false,
      '',
      true,
      body,
    ]);
  };

  const removeFile = id => {
    const updatedFiles = files.filter(file => file.id !== id);
    setFiles(updatedFiles);
  };

  return !activeFolderData?.response ? (
    errorMsg ? (
      <ErrorMessage error={errorMsg} />
    ) : (
      <Spinner center />
    )
  ) : (
    <Container>
      {errorMsg && <ErrorMessage error={errorMsg} />}
      {isUploading ? (
        <Spinner center />
      ) : (
        <>
          {files.map(file => (
            <Wrapper key={file.id}>
              <InputStandard
                type='text'
                disabled
                value={file.name}
                style={{ marginBottom: '0px' }}
                // onChange={handleChangeInput}
              />
              <SelectContainer>
                {file.name !== '' && file.isOriginFile && (
                  <Select
                    options={file.isOriginFile ? options : newFileOptions}
                    style={{ height: '43px' }}
                    value={file.status}
                    onChange={e => onChangeStatus(e.target.value, file.id)}
                  />
                )}
              </SelectContainer>
              <FileUploadContainer>
                {(!file.isOriginFile ||
                  file.status === FILE_STATUS_LIST.replace ||
                  !file.name) && (
                  <Button
                    onClick={() => handleUpload(file.id)}
                    style={{ width: '100%' }}
                  >
                    Choose a file...
                  </Button>
                )}

                <input
                  type='file'
                  id={`file-${file.id}`}
                  ref={el => (hiddenFileInput.current[file.id] = el)}
                  onChange={event => handleChange(event, file.id)}
                  style={{ display: 'none' }}
                />
              </FileUploadContainer>
              <CancelContainer>
                {!file.isOriginFile && (
                  <Button
                    onClick={() => {
                      removeFile(file.id);
                    }}
                    style={{
                      color: 'white',
                      backgroundColor: 'red',
                      padding: '8px 14px',
                    }}
                  >
                    X
                  </Button>
                )}
              </CancelContainer>
            </Wrapper>
          ))}
          <Button onClick={() => handleAdd()}>+</Button>
          <WrapperSubmit>
            <Button onClick={() => handleSubmit()} disabled={isSubmitDisabled}>
              Submit
            </Button>
          </WrapperSubmit>
        </>
      )}
    </Container>
  );
}
